import { useMutation } from "@apollo/client";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import SubmitButton from "../../../../components/common/SubmitButton";
import CustomFormGroup from "../../../../components/form/CustomFormGroup";

import { GET_MEMBER_LIST } from "../../../../graphql/queries/management";
import { handleChangeResetWithdrawPassword } from "../../../management/redux/managementSlice";
import { RESET_MEMBER_WITHDRAW_PASSWORD } from "../../../../graphql/mutations/auth";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/common/CustomErrorMessage";

const ResetWithdrawPasswordForm = ({ handleClose }) => {
  const dispatch = useDispatch();
  const management = useSelector((state) => state.management);
  const { resetWithdrawPassword } = management;

  const [resetMemberPassword, { loading: loadingCreate }] = useMutation(
    RESET_MEMBER_WITHDRAW_PASSWORD,
    {
      variables: {
        member: resetWithdrawPassword.member,
        password: resetWithdrawPassword.newPassword,
      },
      refetchQueries: [{ query: GET_MEMBER_LIST }],
      onCompleted: (data) => {
        if (data) {
          handleClose();
          showSuccessToast();
        }
      },
      onError(err) {
        showErrorToast(err.message);
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    resetMemberPassword();
  };

  const handleChange = (e) =>
    dispatch(
      handleChangeResetWithdrawPassword({
        ...resetWithdrawPassword,
        [e.target.name]: e.target.value,
      })
    );

  return (
    <Form className="notolao" onSubmit={handleSubmit}>
      <CustomFormGroup
        label="ລະຫັດຜ່ານໃໝ່"
        name="newPassword"
        onChange={handleChange}
        type="text"
        value={resetWithdrawPassword.newPassword}
        placeholder="ລະຫັດຜ່ານໃໝ່"
      />

      <div className="text-center">
        <SubmitButton loading={loadingCreate} />
      </div>
    </Form>
  );
};

export default ResetWithdrawPasswordForm;
